import SideBarResults from "./sidebar-results.container";

export default SideBarResults;
